module.exports = "/_next/static/images/05fd64bd6f396a32551a7f25d6b93124-boy-looking-to-the-front-xs@1x.jpg.webp";